import { Alert, Col, Row, Table, Tabs } from "antd"
import {useContext, useState} from "react";
import { TabPane } from "semantic-ui-react"
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
import {TemplateContext} from "../../../../utils/template_context";

export const Educacion = ({ jurado }: any) => {

    const context = useContext(TemplateContext);
    const columnsFormal: any = [
        {
            title: "No.",
            width: 40,
            render: (datos: any, datos2: any, index: number) => {
                return (
                        <span>{index + 1}</span>
                );
            },
            fixed: context.device === "md"? "left": false,
        },
        {
            title: "Titulo",
            width: 200,
            dataIndex: "titulo",
            key: "titulo",
        },
        {
            title: "Nivel de educación",
            width: 140,
            dataIndex: "nivel_educacion",
            key: "nivel_educacion",
        },
        {
            title: "Institución educativa",
            width: 140,
            dataIndex: "institucion_educativa",
            key: "institucion_educativa",
        },
        {
            title: "Ciudad",
            width: 140,
            dataIndex: "ciudad",
            key: "ciudad",
        },
        {
            title: "Graduado",
            width: 140,
            render: (datos: any, datos2: any, index: number) => {
                if (datos.path_anexo) {
                    return <div>{datos.path_anexo}</div>
                }
            },
        },
        // {
        //     title: "Anexo",
        //     width: 140,
        //     render: (datos: any) => (
        //         <a role="button" tabIndex={0} className="button-azul-ghost" onClick={() => modalAnexo(datos)}>Anexo</a>
        //     )
        // },
    ];
    const columnsNoFormal: any = [
        {
            title: "No.",
            width: 70,
            render: (datos: any, datos2: any, index: number) => {
                return (
                        <span>{index + 1}</span>
                );
            },
            fixed: context.device === "md"? "left": false,
        },
        {
            title: "Nombre",
            width: 200,
            dataIndex: "nombre_educacion",
            key: "nombre_educacion",
        },
        {
            title: "Proceso",
            width: 140,
            dataIndex: "nombre_proceso",
            key: "nombre_proceso",
        },
        {
            title: "Duración",
            width: 140,
            dataIndex: "duracion",
            key: "duracion",
        },
        {
            title: "Intitución",
            width: 140,
            dataIndex: "institucion",
            key: "institucion",
        },
        {
            title: "Fecha de inicio",
            width: 140,
            dataIndex: "fecha_inicio",
            key: "fecha_inicio",
        },
        {
            title: "Fecha de terminación",
            width: 160,
            dataIndex: "fecha_terminacion",
            key: "fecha_terminacion",
        },
        {
            title: "Número de horas",
            width: 140,
            dataIndex: "numero_horas",
            key: "numero_horas",
        },
        {
            title: "Ciudad",
            width: 140,
            dataIndex: "ciudad",
            key: "ciudad",
        },
        {
            title: "Graduado",
            width: 140,
            render: (datos: any, datos2: any, index: number) => {
                if (datos.path_anexo) {
                    return <div>{datos.path_anexo}</div>
                }
            },
        },
        // {
        //     title: "Anexo",
        //     width: 140,
        //     render: (datos: any) => (
        //         <a role="button" tabIndex={0} className="button-azul-ghost" onClick={() => modalAnexo(datos)}>Anexo</a>
        //     )
        // },
    ];

    const [openModal, setOpenModal] = useState(false);
    const [documento] = useState('')

    return (
        <>
            <Tabs defaultActiveKey="1" >
                <TabPane tab="Educación formal" key="1">
                    {jurado.educacion_formal !== null && jurado.educacion_formal.length !== 0 ?
                        (
                            <Row>
                                <Col>
                                    <Table
                                        dataSource={jurado.educacion_formal}
                                        columns={columnsFormal}
                                        scroll={{ x: 1500, y: 300 }} 
                                        pagination={false}
                                    />
                                </Col>
                            </Row>
                        )
                        :
                        (
                            <Alert
                                message="No se han diligenciados datos para está sección"
                                type="warning"

                            />
                        )
                    }

                </TabPane>
                <TabPane tab="Educación no formal" key="2">
                    {jurado.educacion_no_formal !== null && jurado.educacion_no_formal.length !== 0 ?
                        (
                            <Row>
                                <Col>
                                    <Table
                                        dataSource={jurado.educacion_no_formal}
                                        columns={columnsNoFormal}
                                        scroll={{ x: 1500, y: 300 }} 
                                        pagination={false}
                                    />
                                </Col>
                            </Row>
                        )
                        :
                        (
                            <Alert
                                message="No se han diligenciados datos para está sección"
                                type="warning"

                            />
                        )
                    }
                </TabPane>
            </Tabs>
            {openModal &&
                <ModalVisualizarDocumentos
                    visualizar={openModal}
                    setVisualizar={setOpenModal}
                    state={{ documento }}
                />
            }
        </>
    )
}
